import { Order } from '@favid-inc/api';
import { OrderByElement, WhereElement } from '@favid-inc/api/lib/rest';
import { Action, Filter } from 'core/generic';
import React from 'react';
import { ArtistOrdersTable } from '..';
import { fetchOrders, reducerOrders } from './controller';

export interface State {
  list: Order[];
  total: number;
  isLoading: boolean;
  orderBy: OrderByElement;
  filter: Filter;
}

const initialState = {
  list: [],
  total: 0,
  isLoading: true,
  filter: {
    page: 0,
    itensPerPage: 20,
  },
  orderBy: {
    attr: 'id',
    exp: 'ASC' as 'ASC',
  },
};

class ListOrdersComponent extends React.Component {
  state = initialState;

  componentDidMount() {
    const { filter, orderBy } = this.state;
    fetchOrders({ filter, orderBy, dispatch: this.dispatch });
  }

  dispatch = (action: Action) => {
    this.setState(reducerOrders(this.state, action));
  };

  onTableFilterChange = async (where: WhereElement[]) => {
    const filter = { ...this.state.filter, where };
    await this.setState({ filter: { ...filter, where } });
    const { orderBy } = this.state;
    fetchOrders({ filter, orderBy, dispatch: this.dispatch });
  };

  onChangeSort = async (orderBy: OrderByElement) => {
    await this.setState({ orderBy });
    const { filter } = this.state;
    fetchOrders({ filter, orderBy, dispatch: this.dispatch });
  };

  onPaginateChange = async (selectedItem: { selected: number }) => {
    const filter: Filter = {
      page: selectedItem.selected,
      itensPerPage: this.state.filter.itensPerPage,
    };
    await this.setState({ filter });
    const { orderBy } = this.state;
    fetchOrders({ filter, orderBy, dispatch: this.dispatch });
  };

  render() {
    const { isLoading, list, filter, orderBy, total } = this.state;

    return (
      <div className='ui segment'>
        <div className='ui header'>
          <h3>Listagem de pedidos</h3>
        </div>
        <div>
          <ArtistOrdersTable
            total={total}
            orders={list}
            filter={filter}
            orderBy={orderBy}
            isLoading={isLoading}
            onPaginateChange={this.onPaginateChange}
            onFilterChange={this.onTableFilterChange}
            onChangeSort={this.onChangeSort}
          />
        </div>
      </div>
    );
  }
}

export const ListOrders = ListOrdersComponent;
